import { useCallback } from 'react';

import { useLocaleStore } from './store';
import { getDateLocale, translate } from './translate';
import { type Locale } from './types';

type TranslationParams = Record<string, string | number>;

const useTranslation = () => {
  const locale = useLocaleStore((state) => state.locale);
  const setLocale = useLocaleStore((state) => state.setLocale);

  const t = useCallback(
    (key: string, params?: TranslationParams) => translate(locale, key, params),
    [locale]
  );

  return {
    dateLocale: getDateLocale(locale),
    locale,
    setLocale,
    t,
  };
};

export { useTranslation };
export type { Locale };
